import { pagination } from 'instantsearch.js/es/widgets'

export function getPaginationParams (searchWrapperEl, paginationWrapper) {
  return {
    container: paginationWrapper,
    scrollTo: searchWrapperEl
  }
}